import {
  Button,
  Divider,
  Image,
  Input,
  message,
  Pagination,
  Popconfirm,
  Switch,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import "../Blog/coupon.css";
import { useNavigate } from "react-router-dom";
import { deleteBlog, editBlog, getBlog } from "./BlogApi";
import { RiSearchLine } from "react-icons/ri";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
import ComponentTitle from "../../../Common/ComponentTitle";

function Blog() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPages] = useState();
  const [loadingMore, setLoadingMore] = useState(false);
  const [blogData, setblogData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filldata, setFilldata] = useState({});
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;
  function FetchBlogData(currentPage) {
    setIsLoading(true);
    getBlog(`?page=${currentPage}&limit=10`)
      .then((response) => {
        if (response.data.status) {
          setIsLoading(false);
          setblogData(response.data.data.blogs);
          setTotalPages(response?.data?.data?.totalPages);
          setCurrentPage(response?.data?.data?.currentPage);
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setIsLoading(false);
        setLoadingMore(false);
      });
  }

  useEffect(() => {
    FetchBlogData(currentPage);
  }, [currentPage, searchTerm]);

  function DeleteAction(checked, record) {
    deleteBlog(`${record.id}`)
      .then((response) => {
        if (response.data.status) {
          message.open(
            messageConfiguration("success", response.data.message, 3)
          );
          FetchBlogData(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const columns = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * 10}.
          </p>
        );
      },
    },
    {
      title: "Blog Title",
      dataIndex: "title",
      key: "title",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <p className="text-xs font-dmsans">{record.title}</p>
      ),
    },
    {
      title: "Blog SubTitle",
      dataIndex: "subtitle",
      key: "subtitle",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <p className="text-xs font-dmsans">{record.subtitle}</p>
      ),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <p className="text-xs font-dmsans">{record.slug}</p>
      ),
    },
    // {
    //   title: "Category Name",
    //   dataIndex: "category",
    //   key: "category",
    //   className: "custom-header font-poppins text-xs",
    //   render: (data, record) => (
    //     <p className="text-xs font-dmsans">
    //       {record?.categories?.categoryName}
    //     </p>
    //   ),
    // },
    {
      title: "Category Slug",
      dataIndex: "categorySlug",
      key: "categorySlug",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <p className="text-xs font-dmsans">{record.categorySlug}</p>
      ),
    },

    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <p className="text-xs font-dmsans">
          {ExtractDate(record.createdAt)}•{ExtractTime(record.createdAt)}
        </p>
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <Button size="small" className="text-black text-sm">
          <EditOutlined
            onClick={() =>
              navigate("/blog/addBlog", {
                state: {
                  fill: record,
                  from: "edit",
                },
              })
            }
          />
        </Button>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",

      render: (data, record) => (
        <Popconfirm
          title={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Are you sure you want to delete this Blog History?
              </p>
            </div>
          }
          onConfirm={() => DeleteAction(undefined, record)}
          okText="Delete"
          cancelText="Cancel"
        >
          <DeleteOutlined className="text-xs font-dmsans" title="Delete" />
        </Popconfirm>
      ),
    },
  ];

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  const ModifyHighlightedStatus = (checked, record) => {
    let payload = {
      title: record.title,
      subtitle: record.subtitle,
      slug: record.slug,
      categoryName: record.categoryName,
      categorySlug: record.categorySlug,
      coverImage: record.coverImage,
      highlighted: checked,
      metaTags: record.metaTags,
      components: record.components?.map((i, index) => {
        switch (i.type) {
          case "rte":
            return {
              type: i.type,
              value: i.value,
            };

          case "tabs": {
            const tabsSection = record?.components?.filter(
              (section) => section.type === "tabs"
            );
            if (tabsSection.length > 0) {
              const tabData = tabsSection[0];
              return {
                type: tabData.type,
                tabs: tabData.tabsSections?.map((section) => section.tabs),
                content: tabData.tabsSections?.map(
                  (section) => section.content
                ),
              };
            }

            return {
              type: "tabs",
              tabs: [],
              content: [],
            };
          }
          case "collapsibles": {
            const collapsibles = record?.components?.filter(
              (section) => section.type === "collapsibles"
            );

            if (collapsibles.length > 0) {
              const collapsible = collapsibles[0];

              return {
                type: collapsible.type,
                title: collapsible.collapsibleSections?.map(
                  (section) => section.title
                ),
                content: collapsible.collapsibleSections?.map(
                  (section) => section.content
                ),
              };
            }

            return {
              type: "collapsibles",
              title: [],
              content: [],
            };
          }
          default:
            return {
              // type: i.type,
              // value: i.value,
            };
        }
      }),
    };
    editBlog(payload, `${record.slug}`)
      .then((response) => {
        if (response.success) {
          FetchBlogData(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <div>
        <ComponentTitle title={"Blog Data "} />
        <div className="flex items-end justify-end mb-4">
          {/* <Search
          placeholder="search  here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        /> */}
          <p
            onClick={() =>
              navigate("/blog/addBlog", {
                state: {
                  fill: filldata,
                  from: "add",
                },
              })
            }
            className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary8"
          >
            Add Blog
          </p>
        </div>

        <div
          style={{ maxHeight: "540px", overflow: "auto" }}
          className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
        >
          <Table
            columns={columns}
            dataSource={blogData}
            className="w-screen sm:w-screen custom-table-header"
            loading={isLoading}
            pagination={false}
          />
        </div>
        <Pagination
          className="mt-2 text-xs w-full flex justify-center items-center"
          onChange={handlePageChange}
          current={currentPage}
          defaultCurrent={1}
          total={10 * totalPage}
          showSizeChanger={false}
        />
      </div>
    </>
  );
}
export default Blog;
